var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/prop-types: 0 */
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { Alert } from "react-bootstrap";
import Icon from "../Icon";

var TIMER_SECONDS = 5;
var ICON_MAP = {
  warning: "warning",
  success: "check_circle",
  danger: "error",
  info: "info"
};

var CustomAlertWrapper = function (_PureComponent) {
  _inherits(CustomAlertWrapper, _PureComponent);

  function CustomAlertWrapper(props) {
    _classCallCheck(this, CustomAlertWrapper);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    _this.globalTick = function () {
      _this.setState({ secondsRemaining: _this.state.secondsRemaining - 1 }, function () {
        if (_this.state.secondsRemaining <= 0) {
          clearInterval(_this.interval);
          _this.props.onDismiss();
        }
      });
    };

    _this.renderAutoDismissTimer = function () {
      return React.createElement("div", {
        className: "alert-timer",
        style: { animationDuration: TIMER_SECONDS + "s" }
      });
    };

    _this.renderIcon = function () {
      var bsStyle = _this.props.bsStyle;

      var name = ICON_MAP[bsStyle] || null;
      return name && React.createElement(Icon, { name: name, className: "alert-icon" });
    };

    _this.state = { secondsRemaining: TIMER_SECONDS };
    return _this;
  }

  CustomAlertWrapper.prototype.componentDidMount = function componentDidMount() {
    if (this.props.autoDismiss) {
      this.interval = setInterval(this.globalTick, 1000);
    }
  };

  CustomAlertWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
    clearInterval(this.interval);
  };

  CustomAlertWrapper.prototype.render = function render() {
    var _props = this.props,
        autoDismiss = _props.autoDismiss,
        children = _props.children,
        className = _props.className,
        hasIcon = _props.hasIcon,
        isGlobal = _props.isGlobal,
        onDismiss = _props.onDismiss;


    var showIcon = isGlobal || hasIcon;

    // Our custom classes for custom-made functionality
    var classes = [className ? className : "", onDismiss ? "alert-dismissible" : "", showIcon ? "alert-has-icon" : "", isGlobal ? "alert-global" : "", autoDismiss ? "alert-auto-dismiss" : ""].join(" ");

    // Create a new object that removes any custom props that the react
    // bootstrap implementation of <Alert> doesn't need.
    var props = _extends({}, this.props);
    delete props.autoDismiss;
    delete props.hasIcon;
    delete props.isGlobal;
    delete props.children;

    return React.createElement(
      Alert,
      _extends({}, props, { className: classes }),
      showIcon && this.renderIcon(),
      children,
      autoDismiss && this.renderAutoDismissTimer()
    );
  };

  return CustomAlertWrapper;
}(PureComponent);

export { CustomAlertWrapper as default };
CustomAlertWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Show a timer on the alert and automatically trigged `onDismiss` after 5 seconds
   */
  autoDismiss: PropTypes.bool,
  /**
   * Automatically display an icon based on the bsStyle
   */
  hasIcon: PropTypes.bool,
  /**
   * Make the alert a global alert notification
   */
  isGlobal: PropTypes.bool
} : {};